import './shared/forEach-polyfill';
import './components/Dots';
import './components/Modal';
import './components/alert';
import './components/cookieHelper';
import '../sass/app.sass';

window.addEventListener('load', function() {
  document.querySelector('.js-t1').classList.add('is-loaded');
});

document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    const customersImg = document.querySelector('.js-customers-img');

    if (customersImg) {
      // set customers modal img
      customersImg.src = customersImg.dataset['src'];
    }
  });
});
